"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Card = _interopRequireDefault(require("../Card"));
var _CellInput = _interopRequireDefault(require("./CellInput"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _MaterialIcon = _interopRequireDefault(require("../MaterialIcon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Text = _interopRequireDefault(require("../Text"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _styledComponents = require("styled-components");
var _styled = require("./styled");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CELL_TYPES = {
  ACTIONS: 'ACTIONS',
  DATA: 'DATA',
  INPUT: 'INPUT'
};
const Table = _ref => {
  let {
    borderColor,
    config = [],
    data = [],
    dataColor,
    disabled = false,
    loading = false,
    headerColor,
    margin = '10px',
    maxHeight = '700px',
    minWidth = '700px',
    noDataText = '',
    onAppend,
    onAppendText = '',
    rowActions = [],
    width = 'auto'
  } = _ref;
  const {
    disabledColor,
    primaryColor,
    primaryLighterColor,
    textColor
  } = (0, _styledComponents.useTheme)();
  const parsedBorderColor = borderColor !== null && borderColor !== void 0 ? borderColor : primaryColor;
  const parsedInnerBorderColor = borderColor !== null && borderColor !== void 0 ? borderColor : primaryLighterColor;
  const parsedDataColor = dataColor !== null && dataColor !== void 0 ? dataColor : textColor;
  const cardProps = {
    color: parsedBorderColor,
    margin,
    overflowX: 'auto',
    padding: '0px',
    width
  };
  const commonProps = {
    borderColor: parsedBorderColor
  };
  const containerProps = {
    maxHeight,
    minWidth
  };
  const extendedConfig = (0, _react.useMemo)(() => [...config, {
    hidden: disabled || (0, _isEmpty.default)(rowActions),
    label: '',
    type: 'ACTIONS'
  }], [config, disabled, rowActions]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.default, _objectSpread(_objectSpread({}, cardProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Header, _objectSpread(_objectSpread({}, commonProps), {}, {
        children: extendedConfig.map((header, index) => {
          const {
            hidden,
            icon,
            iconColor = textColor,
            iconSize = 14,
            key,
            label,
            flex = 1,
            minWidth = 'auto',
            onClick,
            type
          } = header;
          if (hidden) return null;
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.HeaderCell, {
            borderColor: parsedInnerBorderColor,
            flex: flex,
            minWidth: minWidth,
            padding: type === CELL_TYPES.INPUT && !disabled ? '5px 0px' : '5px',
            tabIndex: onClick ? 0 : -1,
            onClick: onClick ? () => onClick(header) : undefined,
            onKeyDown: _ref2 => {
              let {
                key
              } = _ref2;
              return onClick && key === 'Enter' ? onClick(header) : undefined;
            },
            "data-testid": key ? "header-cell-".concat(key) : undefined,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              color: headerColor,
              fontSize: "13px",
              wordBreak: "break-word",
              children: label
            }), !!icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, {
              color: iconColor,
              icon: icon,
              size: iconSize
            })]
          }, "header-".concat(index));
        })
      })), loading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
        active: true
      }), !loading && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Body, _objectSpread(_objectSpread({}, commonProps), {}, {
        "data-testid": "table-body",
        children: [data.map((row, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.BodyRow, {
          children: extendedConfig.map(_ref3 => {
            let {
              accessor,
              format = () => ({}),
              hidden,
              key,
              flex = 1,
              minWidth = 'auto',
              onChange,
              type = CELL_TYPES.DATA
            } = _ref3;
            if (hidden) return null;
            const {
              center,
              color,
              fontSize = '12px',
              fontWeight
            } = format(row);
            const bodyCellProps = {
              borderColor: parsedInnerBorderColor,
              center,
              color: color !== null && color !== void 0 ? color : parsedDataColor,
              'data-testid': key ? "body-cell-".concat(key, "-").concat(index) : undefined,
              flex,
              fontSize,
              fontWeight,
              minWidth
            };
            if (type === CELL_TYPES.INPUT && !disabled) {
              var _row$key;
              return /*#__PURE__*/(0, _react.createElement)(_styled.BodyCell, _objectSpread(_objectSpread({}, bodyCellProps), {}, {
                key: "index-".concat(key),
                padding: "0px"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CellInput.default, {
                value: (_row$key = row[key]) !== null && _row$key !== void 0 ? _row$key : '',
                onChange: value => onChange ? onChange({
                  key,
                  index,
                  row,
                  value
                }) : null
              }));
            }
            if (type === CELL_TYPES.ACTIONS) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.BodyCell, {
                center: true,
                borderColor: parsedInnerBorderColor,
                flex: flex,
                padding: "0px 5px",
                children: rowActions.map((_ref4, actionIndex) => {
                  let {
                    color = () => undefined,
                    disabled = () => false,
                    display = () => true,
                    icon,
                    onClick,
                    title
                  } = _ref4;
                  const rowObject = _objectSpread({
                    tableIndex: index
                  }, row);
                  if (!display(rowObject)) return null;
                  const isDisabled = disabled(rowObject);
                  const iconColor = isDisabled ? disabledColor : color(rowObject);
                  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.ActionContainer, {
                    disabled: isDisabled,
                    title: title,
                    onClick: () => !isDisabled ? onClick(rowObject) : () => null,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, {
                      color: iconColor,
                      icon: typeof icon === 'function' ? icon(row) : icon,
                      size: 16
                    })
                  }, "index-".concat(key, "-").concat(actionIndex));
                })
              }, "index-".concat(key));
            }
            return /*#__PURE__*/(0, _react.createElement)(_styled.BodyCell, _objectSpread(_objectSpread({}, bodyCellProps), {}, {
              key: "index-".concat(key),
              padding: "5px"
            }), typeof accessor === 'function' ? accessor(row[key]) : row[key]);
          })
        }, index)), (0, _isEmpty.default)(data) && !!noDataText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.BodyRow, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.BottomContainer, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              textAlign: "center",
              children: noDataText
            })
          })
        }), onAppend && !disabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.BodyRow, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.BottomContainer, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
              label: onAppendText,
              icon: "add",
              size: 16,
              onClick: onAppend
            })
          })
        })]
      }))]
    }))
  }));
};
Table.propTypes = {
  borderColor: _propTypes.default.string,
  config: _propTypes.default.arrayOf(_propTypes.default.shape({
    accessor: _propTypes.default.func,
    flex: _propTypes.default.number,
    format: _propTypes.default.func,
    hidden: _propTypes.default.bool,
    icon: _propTypes.default.string,
    iconColor: _propTypes.default.string,
    iconSize: _propTypes.default.number,
    key: _propTypes.default.string.isRequired,
    label: _propTypes.default.string,
    minWidth: _propTypes.default.string,
    onChange: _propTypes.default.func,
    onClick: _propTypes.default.func,
    type: _propTypes.default.oneOf([CELL_TYPES.ACTIONS, CELL_TYPES.DATA, CELL_TYPES.INPUT])
  })),
  data: _propTypes.default.array,
  dataColor: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  headerColor: _propTypes.default.string,
  loading: _propTypes.default.bool,
  margin: _propTypes.default.string,
  maxHeight: _propTypes.default.string,
  minWidth: _propTypes.default.string,
  noDataText: _propTypes.default.string,
  onAppend: _propTypes.default.func,
  onAppendText: _propTypes.default.string,
  rowActions: _propTypes.default.arrayOf(_propTypes.default.shape({
    color: _propTypes.default.func,
    disabled: _propTypes.default.func,
    display: _propTypes.default.func,
    icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
    onClick: _propTypes.default.func,
    title: _propTypes.default.string
  })),
  width: _propTypes.default.string
};
var _default = exports.default = Table;